import { render, staticRenderFns } from "./QrCodeProjectDetails.vue?vue&type=template&id=1324a6ac"
import script from "./QrCodeProjectDetails.vue?vue&type=script&lang=js"
export * from "./QrCodeProjectDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports